<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const units = [
  {
    unit: "Unit 3",
    title: "A Bird Came Down the Walk",
    to: "/11th/english/poems/a-bird-came-down-the-walk/",
    focus: "imagery, simile, observation of nature",
    tags: ["Solved", "MCQs", "Literary"],
    stats: ["summary + idea", "2 MCQs", "literary notes"],
  },
  {
    unit: "Unit 6",
    title: "The Echoing Green",
    to: "/11th/english/poems/the-echoing-green/",
    focus: "joy, childhood, symbolic contrast",
    tags: ["Solved", "MCQs", "Literary"],
    stats: ["summary + idea", "2 MCQs", "literary notes"],
  },
  {
    unit: "Unit 9",
    title: "Freedom",
    to: "/11th/english/poems/freedom/",
    focus: "liberty, dignity, tone, theme",
    tags: ["Solved", "MCQs", "Literary"],
    stats: ["summary + idea", "2 MCQs", "literary notes"],
  },
  {
    unit: "Unit 11",
    title: "Those Winter Sundays",
    to: "/11th/english/poems/those-winter-sundays/",
    focus: "silent love, regret, sacrifice",
    tags: ["Solved", "MCQs", "Literary"],
    stats: ["summary + idea", "2 MCQs", "literary notes"],
  },
  {
    unit: "Unit 13",
    title: "Ruba'iyat",
    to: "/11th/english/poems/rubaiyat/",
    focus: "faith, unity, spiritual message",
    tags: ["Solved", "MCQs", "Literary"],
    stats: ["summary + idea", "2 MCQs", "literary notes"],
  },
];

const faqs = [
  {
    question: "What do the poem pages focus on most?",
    answer: "Poem pages me central idea, tone, poetic devices aur MCQs par focus hota hai.",
  },
  {
    question: "Can I use this page to jump directly to a poem chapter?",
    answer: "Haan. Har card se aap seedha us poem ke page par ja sakte hain.",
  },
  {
    question: "Do poem pages include MCQs too?",
    answer: "Haan, poem routes par explained MCQs aur literary notes dono available hain.",
  },
];

usePageSeo({
  title: "11th Class English Poems",
  description: "11th class English poems ke notes, stanza explanation aur question prep ke liye cluster page.",
  keywords: "11th class english poems, first year poem notes",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: units.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `${item.unit}: ${item.title}`,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Poems", item: "/11th/english/poems/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="Poems"
      description="Yahan 11th class English ki tamam poems ek jagah milti hain. Har poem ke sath central idea, explanation aur important MCQs mil sakte hain."
    />

    <EnglishSection
      title="Poem Chapters"
      description="Apni poem choose karein aur us ka matlab, theme aur aham points parhein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="unit in units"
          :key="unit.to"
          :title="`${unit.unit}: ${unit.title}`"
          :description="`Is poem me ${unit.focus} par tawajjuh di gayi hai. Aap ko ${unit.stats.join(', ')} mil jayenge.`"
          :to="unit.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Poems ke bare me chhote aur seedhe jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
